import DocumentFormView from '../../../frontoffice/DocumentFormView';

export default DocumentFormView;
